import React from 'react'
import {useSelector} from "react-redux";
import {SearchResultsByTool} from "./SearchResultsByTool";

export const SearchResultsByUser = ({member}:any) => {
    const tool_cna_search = useSelector((state: any) => state.tool_cna_search)
    const team_obj = useSelector((state: any) => state.organization_team);
    const cna = useSelector((state: any) => state.tool_cna)
    let cna_data = cna.data;
    let cna_archived_data = cna.archived_data;

    let user_data = cna_data.find((data:any) => data.user_id == member.id)
    let user_archived_data = cna_archived_data.find((data:any) => data.user_id == member.id)


    const getAuthorInitials = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            return '--';
        }

        if(author.FirstName == '' || author.FirstName == undefined) {
            return author.EmailAddress.substring(0, 2).toUpperCase()
        }

        return `${author.FirstName.substring(0, 1)}${author.LastName.substring(0, 1)}`;
    }


    // Check if member has any results before rendering
    const hasAnyResults = () => {
        if (!user_data && !user_archived_data) return false;
        
        const tools = ['tomis', 'deliverables', 'activities', 'messages'];
        const selectedTypes = tool_cna_search.search_params.types;
        
        for (const tool of tools) {
            if (selectedTypes.includes('all') || selectedTypes.includes(tool)) {
                let filteredData: any = [];
                const cnaMemberData = user_data?.[tool]?.data || [];
                const cnaMemberDataArchived = user_archived_data?.[tool]?.data || [];

                if (tool_cna_search.search_params.include.includes('active')) {
                    filteredData = [...cnaMemberData];
                }
                if (tool_cna_search.search_params.include.includes('archive')) {
                    filteredData = [...filteredData, ...cnaMemberDataArchived];
                }

                if (tool_cna_search?.search_params?.q != undefined && tool_cna_search.search_params.q.trim() != '') {
                    const query = tool_cna_search.search_params.q.toLowerCase();
                    filteredData = filteredData.filter((item: any) => {
                        const title = item.title ? item.title.toLowerCase() : '';
                        const description = item.description ? item.description.toLowerCase() : '';
                        return title.includes(query) || description.includes(query);
                    });
                }

                if (filteredData.length > 0) return true;
            }
        }
        return false;
    };

    // Return null if member has no results (suppress empty members)
    if (!hasAnyResults()) {
        return null;
    }

    return (
        <div className="col-12">
            <div className='d-flex align-items-center mb-1'>
                <div className="rounded-circle" style={{backgroundColor: 'teal', padding: '5px', color: 'white', display: 'inline', textAlign: 'center', fontSize: '12px', fontFamily: 'sans-serif'}}
                >
                    {getAuthorInitials(member.id)}
                </div>

                <div className='mx-1'>{member.FirstName}</div>
            </div>

            {(() => {
                // Helper function to check if tool has results
                const hasResults = (toolName: string) => {
                    if (!user_data || !user_data[toolName] || !user_archived_data || !user_archived_data[toolName]) {
                        return false;
                    }
                    let filteredData: any = [];
                    let cnaMemberData = user_data[toolName]?.data || [];
                    let cnaMemberDataArchived = user_archived_data[toolName]?.data || [];

                    if (tool_cna_search.search_params.include.includes('active')) {
                        filteredData = [...cnaMemberData];
                    }
                    if (tool_cna_search.search_params.include.includes('archive')) {
                        filteredData = [...filteredData, ...cnaMemberDataArchived];
                    }

                    // Apply search filters
                    if (tool_cna_search?.search_params?.q != undefined && tool_cna_search.search_params.q.trim() != '') {
                        const query = tool_cna_search.search_params.q.toLowerCase();
                        filteredData = filteredData.filter((item: any) => {
                            const title = item.title ? item.title.toLowerCase() : '';
                            const description = item.description ? item.description.toLowerCase() : '';
                            return title.includes(query) || description.includes(query);
                        });
                    }

                    return filteredData.length > 0;
                };

                const results: JSX.Element[] = [];

                if ((tool_cna_search.search_params.types.includes('all') || tool_cna_search.search_params.types.includes('tomis')) && hasResults('tomis')) {
                    results.push(
                        <React.Fragment key="tomis">
                            <h6 style={{textDecoration: "underline"}} className={'mt-2'}>TOMIs™</h6>
                            <SearchResultsByTool user_data={user_data} user_archived_data={user_archived_data} tool={'tomis'} />
                        </React.Fragment>
                    );
                }

                if ((tool_cna_search.search_params.types.includes('all') || tool_cna_search.search_params.types.includes('deliverables')) && hasResults('deliverables')) {
                    results.push(
                        <React.Fragment key="deliverables">
                            <h6 style={{textDecoration: "underline"}} className={'mt-2'}>Deliverables</h6>
                            <SearchResultsByTool user_data={user_data} user_archived_data={user_archived_data} tool={'deliverables'} />
                        </React.Fragment>
                    );
                }

                if ((tool_cna_search.search_params.types.includes('all') || tool_cna_search.search_params.types.includes('activities')) && hasResults('activities')) {
                    results.push(
                        <React.Fragment key="activities">
                            <h6 style={{textDecoration: "underline"}} className={'mt-2'}>Activities</h6>
                            <SearchResultsByTool user_data={user_data} user_archived_data={user_archived_data} tool={'activities'} />
                        </React.Fragment>
                    );
                }

                if ((tool_cna_search.search_params.types.includes('all') || tool_cna_search.search_params.types.includes('messages')) && hasResults('messages')) {
                    results.push(
                        <React.Fragment key="messages">
                            <h6 style={{textDecoration: "underline"}} className={'mt-2'}>Messages</h6>
                            <SearchResultsByTool user_data={user_data} user_archived_data={user_archived_data} tool={'messages'} />
                        </React.Fragment>
                    );
                }

                return results.length > 0 ? (
                    <>
                        {results}
                        <hr/>
                    </>
                ) : null;
            })()}
        </div>
    )
}
